import React from 'react';
import { StatusType } from 'styles';
import { StatusBubble } from 'UI';

const ClaimStatus = ({ status, statusType }: { status: string; statusType: StatusType }) => (
  <StatusBubble statusType={statusType}>{status}</StatusBubble>
);

export default ClaimStatus;
